import { jsx as _jsx } from "react/jsx-runtime";
import MuiSnackbar from "@mui/material/Snackbar";
export const Snackbar = ({ show, position, children, }) => {
    return (_jsx(MuiSnackbar, { open: show, anchorOrigin: position, children: children }));
};
